import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  headerText: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.white,
    height: 24
  },
  // Applied tag + remove (trash) button shown together on the right of a coverage section header
  // (#32149, #32150).
  appliedActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  addFormContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.onCardDivider.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4, 8)
  },
  button: {
    padding: theme.spacing(2, 4)
  },
  // alert styles
  alert: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexGrow: 1
  },
  alertIcon: {
    paddingTop: theme.spacing(1)
  },
  // No paddingTop — icon centers cleanly with single-line message under the parent's alignItems: center
  alertIconInline: {
    display: 'block'
  },
  alertMessage: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.onCard.white,
    maxWidth: '362px'
  },
  alertMessageFull: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.onCard.white
  },
  // Single-line variant with no line-height so the text sits on the same horizontal baseline
  // as the info icon (used by the earthquake-zone callout, issue #32439).
  alertMessageInline: {
    fontSize: 12,
    color: theme.onCard.white
  },
  // Wrapper for an alert row that sits below other fields — adds breathing room so the icon +
  // text don't crowd the last checkbox/select above (used by the earthquake-zone callout).
  alertRow: {
    paddingTop: theme.spacing(2)
  },
  singleBottom: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end'
  },
  item: {
    backgroundColor: theme.colorPalette.green_80,
    width: '100%',
    borderRadius: theme.sizes.roundCorners,
    margin: theme.spacing(1, 0),
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, borderRadius: theme.sizes.innerCorners })
  },
  itemTitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 4)
  },
  itemTitle: {
    fontSize: 14,
    fontWeight: 400,
    margin: 0,
    color: theme.onCard.beige_50,
    flexGrow: 1
  },
  actionButtons: {
    flexShrink: 0,
    width: 'auto'
  },
  itemStack: {
    display: 'flex',
    flexDirection: 'column'
  },
  itemLabel: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.beige_60,
    textTransform: 'uppercase'
  },
  itemValue: {
    fontSize: 16,
    lineHeight: '24px',
    color: theme.onCard.white
  },
  divider: {
    width: '1px',
    height: '34px',
    backgroundColor: theme.colorPalette.green_75,
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_60 })
  },
  deleteButton: {
    color: theme.colorPalette.orange_75,
    ...reskinStyles(theme, { color: theme.colors.action_text }),
    paddingLeft: theme.spacing(2),
    '& img': {
      height: 24,
      width: 24
    }
  },
  expandIcon: {
    color: theme.colors.action_text,
    marginLeft: theme.spacing(2),
    '& img': {
      height: 24,
      width: 24
    }
  },
  iconFold: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform var(--motion-duration-close, 0ms) var(--motion-ease-out, ease-out)'
  },
  icon: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform var(--motion-duration-close, 0ms) var(--motion-ease-out, ease-out)',
    transform: 'rotate(180deg)'
  },
  itemContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    borderTop: `1px solid ${theme.onCardDivider.beige_50}`,
    padding: theme.spacing(4)
  },
  radioLabel: {
    color: theme.onCard.white
  },
  fieldHelperText: {
    marginTop: theme.spacing(-3)
  },
  itemTitleWrapper: {
    padding: theme.spacing(1, 0),
    lineHeight: '20px'
  },
  itemTypeLabel: {
    color: theme.colorPalette.beige_60,
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  inGroundInstruction: {
    color: theme.colorPalette.red_50,
    fontWeight: 700
  }
});

export default makeStyles(styles);
